import translate from '../utils/translations'

export default {
  name: 'input-file',

  ui: {
    input: '[js-input-file-input]',
    label: '[js-input-file-label]',
  },

  events: [
    {
      on: 'change',
      target: 'input',
      handle (e) {
        const hasValue = e.target.value !== ''
        this.ui.label.innerHTML = hasValue ? e.target.value.split('\\').pop() : translate('INPUT_FILE_EMPTY')
        if (hasValue) {
          this.ui.label.classList.remove('has-placeholder')
        } else {
          this.ui.label.classList.add('has-placeholder')
        }
      },
    },
  ],

  componentDidMount () {
  },
}
